// action types
const UPDATE_OFFLINE_STATUS = 'rp/offline/UPDATE_OFFLINE_STATUS'

// reducer
export default (state = false, { payload, type }) => {
  switch (type) {
    case UPDATE_OFFLINE_STATUS:
      return payload
    default:
      return state
  }
}

// action creators
// payload = boolean
export const updateOfflineStatus = payload => ({
  type: UPDATE_OFFLINE_STATUS,
  payload,
})
